import React from 'react';
import s from './Steps.module.css';
import Button from '../../../../shared/ui/button/Button';
import SocialLogin from '../../../auth-page/widgets/steps/SocialLogin';
import { NavLink } from 'react-router-dom';
import IconFullLeftArrow from '../../../../shared/ui/icons/IconFullLeftArrow';
export interface RegistrationFlowProps {
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    formErrors: {
        email: string;
    };
    isLoading: boolean;
    formData: {
        email: string;
    };
    handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const RegistrationStep1: React.FC<RegistrationFlowProps> = ({
    handleInputChange,
    formErrors,
    isLoading,
    formData,
    handleSubmit,
}) => {
    return (
        <form
            className={s.form}
            onSubmit={(e) => {
                e.preventDefault();
            }}
        >
            <div className={s.top_container}>
                <p className={s.subtitle}>
                    Join the community of worlds trusted brands and 1,000+ creators!
                </p>
                <SocialLogin />
                <div className={s.divider}>or</div>
                <div className={s.input_container}>
                    <p className={s.label}>Email</p>
                    <input
                        className={`${s.input} ${formErrors.email ? s.input_error : ''}`}
                        id="email"
                        type="email"
                        placeholder="Email adress"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                {formErrors.email && <div className={s.error_text}>{formErrors.email}</div>}
            </div>

            <Button
                text={isLoading ? 'Loading...' : 'Continue'}
                state={isLoading ? 'loading' : formData.email.length === 0 ? 'disabled' : 'enabled'}
                icon={<IconFullLeftArrow />}
                iconPosition="right"
                onClick={() => {
                    handleSubmit({ preventDefault: () => {} } as React.FormEvent<HTMLFormElement>);
                }}
                style={{
                    background: '#FFDD35',
                    borderRadius: '26px',
                    fontWeight: '600',
                    height: '40px',
                    marginBottom: '20px',
                    marginTop: '90px',
                }}
            />
            <p className={s.subtitle}>
                By signing up you accept our{' '}
                <a href="/terms-of-use" className={s.link}>
                    Terms of Service
                </a>{' '}
                and{' '}
                <a href="/privacy-policy" className={s.link}>
                    Privacy Policy
                </a>
                .
            </p>

            {/* <div className={s.text_container}>
                <div className={s.text}>Already have an account?</div>
                <NavLink className={s.link} to="/signin">
                    Login here
                </NavLink>
            </div> */}
        </form>
    );
};

export default RegistrationStep1;
